import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { UserSearch } from '@/types';
import DialogSearchNoRemoteTable from './DialogSearchNoRemoteTable';
import DialogSearchRemoteTable, { SupplierResult } from './DialogSearchRemoteTable';

const useStyles = makeStyles(() => ({
  root: {
    height: '100vh',
  },
  content: {
    paddingTop: 0,
    width: '780px',
  },
}));

interface DialogSearchProps {
  isRemote?: boolean;
  close: () => void;
  updateOptionSelected: (user: UserSearch[] | UserSearch | SupplierResult | string | null) => void;
  title?: string;
  level?: number;
  isFixedLevel?: boolean;
  defaultValue?: string;
  isSupplier?: boolean;
  plant?: string;
  role?: string[];
  authorizedPlants?: boolean;
  emptyUserAllowed?: boolean;
  assignedUser?: string;
  saveButtonLabel?: string;
}

type DialogSearchSelection = UserSearch[] | UserSearch | SupplierResult | string | null;

const DialogSearch: React.FC<DialogSearchProps> = (props) => {
  const { isRemote = false, close, updateOptionSelected, title = '', level, isFixedLevel, defaultValue, isSupplier = false, plant, role,
    authorizedPlants = false, emptyUserAllowed = false, assignedUser, saveButtonLabel } = props;
  const [selectedOption, setSelectedOption] = useState<DialogSearchSelection>(null);
  const [disabledSave, setSaveDisabled] = useState(true);
  const { t } = useTranslation();
  const classes = useStyles();

  const sendSelectedValue = () => {
    updateOptionSelected(selectedOption);
    close();
  };

  return (
    <Dialog
      open
      maxWidth="md"
      aria-labelledby="form-dialog-title"
      className={classes.root}
      data-testid="dialog-search"
    >
      <DialogTitle id="form-dialog-title">{title}</DialogTitle>
      <DialogContent className={classes.content}>
        {isRemote
          ? (
            <DialogSearchRemoteTable
              isSupplier={isSupplier}
              defaultValue={defaultValue}
              level={level}
              isFixedLevel={isFixedLevel}
              plant={plant}
              authorizedPlants={authorizedPlants}
              setSelectedOption={setSelectedOption}
              setSaveDisabled={setSaveDisabled}
            />
          )
          : (
            <DialogSearchNoRemoteTable
              plant={plant}
              role={role}
              setSelectedOption={setSelectedOption}
              setSaveDisabled={setSaveDisabled}
              assignedUser={assignedUser}
            />
          )}
      </DialogContent>
      <DialogActions>
        <Button
          disabled={emptyUserAllowed ? false : disabledSave}
          variant="contained"
          color="primary"
          onClick={sendSelectedValue}
          id="save-btn-dialog-search"
          data-testid="save-btn-dialog-search"
        >
          {saveButtonLabel || t('dialog.save')}
        </Button>
        <Button
          color="primary"
          onClick={close}
          id="cancel-btn-dialog-search"
          data-testid="cancel-btn-dialog-search"
        >
          {t('dialog.cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default (DialogSearch);
